// @flow
import config from '../../config';
import { createApiCall } from './api-factory';
import { buildScenarioQueryParams } from './search-scenario-optimizations-request';

const BASE_URL = config.SURCHARGES_COMPARISON_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildScenarioQueryParams);

const getSurchargesNoSurcharges = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_count';
    return makeApiCall(endpoint, query);
};

const getNoNonShipmentSurcharges = (query: Query | string): Promise<any> => {
    const endpoint = '/non_shipment_surcharges_count';
    return makeApiCall(endpoint, query);
};

const getNonShipmentSurchargesCost = (query: Query | string): Promise<any> => {
    const endpoint = '/non_shipment_surcharges_cost';
    return makeApiCall(endpoint, query);
};

const getSurchargesCost = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_cost';
    return makeApiCall(endpoint, query);
};

const getAuditableSurchargesCost = (query: Query | string): Promise<any> => {
    const endpoint = '/auditable_surcharges_cost';
    return makeApiCall(endpoint, query);
};

const getComparisonSurchargesCost = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_comparison_cost';
    return makeApiCall(endpoint, query);
};

const getSurchargesComparisonRecords = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_comparison';
    return makeApiCall(endpoint, query);
};

export {
    getSurchargesNoSurcharges,
    getNoNonShipmentSurcharges,
    getNonShipmentSurchargesCost,
    getSurchargesCost,
    getAuditableSurchargesCost,
    getComparisonSurchargesCost,
    getSurchargesComparisonRecords,
};
